import { render } from "./MenuEcosystem.vue?vue&type=template&id=214f9160&scoped=true"
import script from "./MenuEcosystem.vue?vue&type=script&lang=js"
export * from "./MenuEcosystem.vue?vue&type=script&lang=js"

import "./MenuEcosystem.vue?vue&type=style&index=0&id=214f9160&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214f9160"]])

export default __exports__